<template>
  <div class="privacy-policy">
    <!-- <div class="top-head">
      <button class="logout-button" @click="goBack">返回</button>
    </div> -->
    <h1>青牛出关网站-个人信息保护政策</h1>
    <p>您可以根据以下索引阅读相应章节，以了解本政策的详细内容：</p>
    <ol>
      <li>我们如何收集、存储、使用您的个人信息</li>
      <li>我们如何使用Cookie和同类技术</li>
      <li>我们如何共享、传输、转让、公开披露您的个人信息</li>
      <li>我们如何保护您的个人信息</li>
      <li>您的权利</li>
      <li>我们如何处理未成年人的个人信息</li>
      <li>适用法律及管辖</li>
      <li>本政策如何更新</li>
      <li>如何联系我们</li>
      <li>名词定义</li>
    </ol>
    <p>
      本政策适用于北京青牛出关科技有限公司（以下简称青牛出关或我们）通过picopi.cn动漫网站提供的产品及服务。
      我们的注册/常用办公地址为：北京市朝阳区鼓楼外大街19号B幢。
    </p>
    <p>
      青牛出关动漫网站产品或服务中可能含有第三方产品和/或服务的链接或信息。如果第三方产品和/或服务要求您填写相关信息，
      请仔细查看该第三方的个人信息保护政策，并审慎提供个人信息。本个人信息保护政策不适用于第三方向您直接收集信息的行为，
      青牛出关无法控制第三方的行为，亦不会对该等第三方收集和/或使用您信息的行为承担任何责任。
    </p>
    <h2>1. 我们如何收集、存储、使用您的个人信息</h2>
    <p>
      我们提供的产品或服务包括基本业务功能和扩展业务功能。我们提供的基本业务功能需要依赖部分信息才得以运行，您选择使用该项业务功能时，则需要向我们提供或允许我们收集必要的信息，否则基本业务功能将无法正常运行，我们将无法为您服务；
    </p>
    <p>我们基于不同业务功能收集您的个人信息详情如下：</p>
    <h3>1.1 帮助您注册成为青牛出关用户</h3>
    <p>
      当您注册青牛出关账号时，我们为落实网络实名制要求，向您提供用户服务，您需要提供您的手机号、验证码。如果您不提供上述信息，您将无法注册成为青牛出关动漫网站用户，使用动漫版权作品授权等功能，但不影响您以游客身份使用浏览服务。
    </p>
    <h3>1.2 维护产品安全及时排除故障</h3>
    <p>
      为维护我们服务的正常运行，以及保障您的账号安全、排查产品故障、改进及优化我们的服务，我们会收集您的设备型号信息及登陆IP地址、操作日志信息、设备品牌、系统版本、CPU信息。
      这类信息是为提供服务必须收集的信息，收集后即作去标识化处理，不会用于识别任何特定的用户。
    </p>
    <h3>1.3 为您提供内容浏览服务</h3>
    <p>
      为向您提供内容浏览服务，识别账号异常状态，了解设备适配性，保证我们提供的产品或服务的正常运行，我们会收集您的操作系统版本、操作系统语言、浏览器类型、IP地址、访问网页、访问时间。
    </p>
    <h3>1.4 为您提供支付功能</h3>
    <h4>(1) 下单及订单管理</h4>
    <p>
      当您准备对您购买的动漫产品进行结算时，青牛出关动漫网站系统会生成您购买该项目的订单。该订单中会载明订单号、您所购买的项目服务信息、下单时间、您应支付的款项金额及支付方式。此类信息属于该功能的必需信息，若您不同意采集并共享这类信息，您将无法正常使用在线结算功能。
    </p>
    <h4>(2) 支付功能</h4>
    <p>
      当您使用在线支付功能购买平台动漫产品时，我们会上传您的支付信息（支付金额、支付时间、购买明细、订单号信息）；此类信息属于该功能的必需信息，若您不同意采集并共享这类信息，您将无法正常使用在线支付功能。
    </p>
    <p>
      前述信息是我们提供产品或服务之必需，您不同意我们收集前述信息将导致您无法使用青牛出关的产品或服务。
    </p>
    <h3>1.5 无需征得同意的情形</h3>
    <p>
      根据法律法规、国家标准规定，以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的授权同意：
    </p>
    <ul>
      <li>1) 与国家安全、国防安全直接相关的。</li>
      <li>2) 与公共安全、公共卫生、重大公共利益直接相关的。</li>
      <li>3) 与犯罪侦查、起诉、审判和判决执行等直接相关的。</li>
      <li>
        4)
        出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您的同意的。
      </li>
      <li>5) 所收集的个人信息是您自行向社会公众公开的。</li>
      <li>
        6)
        从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
      </li>
      <li>7) 根据您要求签订和履行合同所必需的。</li>
      <li>
        8)
        用于维护我们所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。
      </li>
      <li>9) 法律法规规定的其他情形。</li>
    </ul>
    <h3>1.6 您理解并同意</h3>
    <p>
      我们向您提供的产品或服务是不断更新发展的。如果某一项产品或服务未能在前述说明中且确有必要收集您的信息的，我们会通过页面提示、私信、网站公告、表单等方式另行征得您的同意。
    </p>
    <h2>2. 我们如何使用Cookie和同类技术</h2>
    <h3>2.1 为确保网站正常运转</h3>
    <p>
      我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标志符、站点名称以及一些号码和字符。借助Cookie，网站能够记住您的用户身份、存储您的偏好。以此帮助您免去重复填写个人信息、输入历史搜索内容等繁琐。
    </p>
    <p>
      我们不会将Cookie用于本政策所述目的之外的其他用途。您可根据自己的偏好管理或删除Cookie。如您的浏览器允许，您可以通过浏览器设置阻止Cookie。但如果您这么做，可能会影响您安全访问我们的网站，且可能在每一次访问我们的网站时需要更改用户设置。
    </p>

    <h2>3. 我们如何共享、传输、转让、公开披露您的个人信息</h2>

    <h3>3.1 共享</h3>
    <p>我们不会向任何公司、组织和个人共享您的个人信息，但下列情况除外：</p>
    <ul>
      <li>
        1)
        在获得明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
      </li>
      <li>
        2)
        在法定条件下共享：我们可能会根据法律法规规定、诉讼或争议解决的需要、按政府主管部门或司法机关的要求，对外共享您的个人信息。
      </li>
    </ul>

    <h3>3.2 转让</h3>
    <p>我们不会将您的个人信息转让给任何第三方，但下列情况除外：</p>
    <ul>
      <li>
        1) 在获得您的明确同意的前提下，我们会向其他第三方转让您的个人信息。
      </li>
      <li>
        2)
        在涉及合并、收购、资产转让等情形时，如涉及到个人信息转让，我们会通过短信、电话等方式向您告知个人信息接收方的名称和联系方式，并征求您的同意。我们会要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新征求您的授权同意。
      </li>
    </ul>

    <h3>3.3 公开披露</h3>
    <p>我们不会公开披露您的个人信息，但下列情况除外：</p>
    <ul>
      <li>1) 获得您明确同意后或基于您的主动选择。</li>
      <li>
        2)
        基于法律的披露：在法律、法律程序、诉讼、政府主管部门或司法机关要求的情况下，我们可能会公开披露您的个人信息。
      </li>
    </ul>

    <h3>
      3.4
      根据法律法规及国家标准，以下情形中我们可能会共享、转让、公开披露您的个人信息无需征得您的同意：
    </h3>
    <ul>
      <li>1) 为订立、履行您作为一方当事人的合同所必需；</li>
      <li>2) 为履行法定职责或者法定义务所必需；</li>
      <li>
        3)
        为应对突发公共卫生事件，或者紧急情况下为保护您的生命健康和财产安全所必需；
      </li>
      <li>
        4) 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
      </li>
      <li>
        5)
        依照相关法律规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；
      </li>
      <li>6) 法律、行政法规规定的其他情形。</li>
    </ul>
    <h2>4. 我们如何保护您的个人信息</h2>

    <h3>4.1 存储</h3>
    <p>
      我们会将在中华人民共和国大陆地区运营中所收集和产生的您的个人信息存储在我们在中华人民共和国境内的数据中心。
    </p>
    <p>
      我们目前未跨境传输在中华人民共和国大陆地区运营中所收集和产生的信息，若我们需要将您在中国大陆地区采集的个人信息转移到其他司法管辖区的，我们会遵照相关适用法律的要求，进行数据出境安全影响评估、落实统一的安全保障措施并征求您的同意，保证所有这类转移满足当地适用的数据保护法的要求。
    </p>
    <p>
      我们承诺，除非法律法规另有要求，或者您要求我们依法删除个人信息的情况以外，我们对您的个人信息的存储时间将限于实现您授权使用的目的所必需的最短时间。
    </p>
    <p>
      如我们因经营不善或其他原因出现部分或者全部停止运营的情况，除非法律法规或规范性文件另有规定或者双方另有约定，我们将会向您告知此类情况，并停止对您个人信息进行收集，同时删除已收集到的个人信息或对其做匿名化处理。
    </p>
    <h2>4. 我们如何保护您的个人信息</h2>

    <h3>4.1 存储</h3>
    <p>
      我们会将在中华人民共和国大陆地区运营中所收集和产生的您的个人信息存储在我们在中华人民共和国境内的数据中心。
    </p>
    <p>
      我们目前未跨境传输在中华人民共和国大陆地区运营中所收集和产生的信息，若我们需要将您在中国大陆地区采集的个人信息转移到其他司法管辖区的，我们会遵照相关适用法律的要求，进行数据出境安全影响评估、落实统一的安全保障措施并征求您的同意，保证所有这类转移满足当地适用的数据保护法的要求。
    </p>
    <p>
      我们承诺，除非法律法规另有要求，或者您要求我们依法删除个人信息的情况以外，我们对您的个人信息的存储时间将限于实现您授权使用的目的所必需的最短时间。
    </p>
    <p>
      如我们因经营不善或其他原因出现部分或者全部停止运营的情况，除非法律法规或规范性文件另有规定或者双方另有约定，我们将会向您告知此类情况，并停止对您个人信息进行收集，同时删除已收集到的个人信息或对其做匿名化处理。
    </p>

    <h3>4.2 保护</h3>
    <p>
      我们十分重视您的个人信息安全，为此我们采用了符合行业标准的安全技术措施及配套的组织架构和管理体系，以最大程度防止您的个人信息被泄露、毁损、误用、未授权访问、未授权披露或更改，具体包括：
    </p>

    <h4>4.2.1 数据安全措施</h4>
    <p>
      在数据安全传输方面，我们采用了传输层安全协议密码技术，通过Https防止传输链路被窃听、截取，以建立安全的隐私数据环境，保证数据的私密性和完整性；我们还会使用Token技术保护数据在其传输过程中的安全，并使用妥善的保护机制以防止数据遭到恶意攻击；此外，我们还将对您的信息采取加密存储进行安全保护。
    </p>
    <p>
      在数据访问和使用的安全控制方面，我们实施了严格的数据权限控制机制对处理您的个人信息的行为进行监控，避免数据被违规访问和未授权使用。我们会定期对本产品的所有接口进行安全性扫描，并采取防范恶意代码、流量攻击的保护措施，防止您的个人信息遭遇未授权的访问、公开披露、使用、修改、人为或意外的损坏或丢失。
    </p>
    <h4>4.2.2 存储时间</h4>
    <p>
      我们承诺您个人信息的存储时间始终处于合理必要期限内。例如《中华人民共和国电子商务法》规定：商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。例如《网络安全法》要求按照规定留存相关的网络日志不少于六个月。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：完成与您相关的服务所需保留的必要期限；应对您可能的查询或投诉；保证我们为您提供服务的安全和质量；您是否同意更长的留存期间；是否存在关于保留期限的其他特别约定或法律法规规定。对于超出期限的个人信息，我们会立即删除或匿名化处理。
    </p>

    <h3>4.3 安全保护措施</h3>
    <p>
      我们已使用符合业界标准的安全保护措施以保护您提供的个人信息，防止数据遭到未授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与服务器之间交换数据时受SSL加密保护；我们对青牛出关网站提供https安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；我们会进行安全和个人信息保护培训，加强员工对于保护个人信息重要性的认识。
    </p>

    <h3>4.4 安全事件处理</h3>
    <p>
      如不幸发生个人信息安全事件，我们将按照法律法规的要求，启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
    </p>
    <h2>5. 您的权利</h2>
    <p>
      按照中国相关的法律、法规、标准，我们保障您对自己的个人信息行使以下权利：
    </p>

    <h3>5.1 查询、删除您的个人信息</h3>

    <h4>（一）查阅/复制或更正/补充您的个人信息</h4>
    <p>
      如您的账号处于正常使用状态，您有权随时登录并访问您的PicoPico账号，查阅您的个人信息，包括您的账号信息、您的个人资料、发布的评论和「动态」。如您发现我们处理的您的个人信息不准确或者不完整的，或者在法律法规规定的其他情况下，您可以更正、补充您的个人信息。您可以通过下述路径行使此类权利：
    </p>
    <ol>
      <li>您可以通过点击“我-个人中心”查阅您的信息。</li>
      <li>
        您有权获取您的个人信息副本（仅限于您本人在平台存储的个人信息），您可以随时与我们联系，联系邮箱为：help@picopi.cn。我们将在15个工作日内回复您的请求。
      </li>
    </ol>
    <p>
      需要特别说明的是，根据法律法规的要求或者我们业务运营的需要，我们收集的某些信息（例如订单信息）可能无法修改。
    </p>

    <h4>
      （二）发生以下情形，我们将删除已收集的相关个人信息，您也可以向我们提出删除个人信息的请求：
    </h4>
    <ol>
      <li>处理目的已实现、无法实现或者为实现处理目的不再必要；</li>
      <li>我们停止提供产品或者服务，或者保存期限已届满；</li>
      <li>您撤回同意的；</li>
      <li>我们违反法律、行政法规或者违反约定处理个人信息；</li>
      <li>法律、行政法规规定的其他情形。</li>
    </ol>
    <p>
      如此时法律、行政法规规定的保存期限尚未届满，我们将停止除存储和采取必要的安全保护措施之外的处理。
    </p>
    <h3>5.2 响应您的上述请求</h3>
    <ol>
      <li>
        为保障安全，我们可能会要求您先验证您的身份，再响应您的上述请求。如通过上述路径无法解决，您可以随时通过本政策列明的方式联系我们，一般情况下我们将在15个工作日内作出回复。
      </li>
      <li>
        对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求（例如，涉及备份磁带上存放的信息），我们可能会予以拒绝。
      </li>
      <li>
        在以下情形中，按照法律法规要求，我们将无法响应您的请求：
        <ol type="a">
          <li>与国家安全、国防安全直接相关的；</li>
          <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
          <li>与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
          <li>有充分证据表明您存在主观恶意或滥用权利的；</li>
          <li>
            响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
          </li>
          <li>涉及商业秘密的。</li>
        </ol>
      </li>
    </ol>
    <h2>6. 我们如何处理未成年人的个人信息</h2>
    <ol>
      <li>
        我们的产品主要面向成年人。受限于本产品特性，网站并未开发其他识别您真实年龄的产品功能。
      </li>
      <li>
        不满十四周岁未成年人（本政策所指“未成年人”，特指不满十四周岁的未成年人），在未获得父母或监护人同意的前提下，不应创建自己的个人信息主体账户。如果您的年龄在14周岁以下，在使用我们的产品和/或服务前，请您务必在监护人的陪同下阅读本政策，并确保已征得您的监护人明确同意后，再使用我们的服务。
      </li>
      <li>
        对于经监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、监护人明确同意或者保护未成年人所必要的情况下处理此信息。
      </li>
      <li>
        如果您的监护人不同意您按照本政策使用我们的服务或向我们提供个人信息，请您立即终止使用我们的服务并及时通知我们。
      </li>
      <li>
        如果您是父母或监护人，对您所监护的未成年人使用我们的产品/服务或其向我们提供的用户信息有任何疑问时，请您及时与我们联系，请发邮件至help@picopi.cn，一般情况下我们将在5个工作日内回复；
      </li>
      <li>
        如果我们发现在未获得监护人同意的情况下收集了未成年的个人信息，则会设法尽快删除相关未成年人信息。
      </li>
    </ol>
    <h2>8. 适用法律及管辖</h2>
    <p>
      本个人信息保护政策适用中华人民共和国大陆地区法律。本政策项下争议，由被告住所地法院管辖。
    </p>
    <h2>9. 本政策如何更新</h2>
    <h3>9.1</h3>
    <p>
      我们可能会根据业务的调整、法律法规或政策的变化而适时变更。未经您明确同意，我们不会削减您按照本个人信息保护政策所应享有的权利。本政策更新后，我们会发出更新版本，并在更新后的条款生效前通过私信、通知、公告或其他适当的方式提醒您更新的内容，以便您及时了解本政策的最新版本。
    </p>
    <h3>9.2</h3>
    <p>
      如本政策变更的类型涉及个人信息的处理目的、处理方式和处理的个人信息种类发生变更的，我司将重新取得您的同意。若您不同意修改后的青牛出关个人信息保护政策，您有权并应立即停止使用我们的产品和/或服务。如果对本政策的更新存在疑义，请您及时通过本政策公示的联系方式与我方联系。
    </p>
    <h2>10. 如何联系我们</h2>
    <h3>10.1</h3>
    <p>
      我们已设立了个人信息保护负责人，如果您对本个人信息保护政策有任何疑问、意见或建议，请发送邮件至：help@picopi.cn，一般情况下我们将在15日内回复。
    </p>
    <h2>11. 名词定义</h2>
    <h3>11.1 个人信息</h3>
    <p>
      是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
    </p>
    <h3>11.2 敏感个人信息</h3>
    <p>
      是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
    </p>
    <h3>11.3 匿名化</h3>
    <p>是指个人信息经过处理无法识别特定自然人且不能复原的过程。</p>
    <h3>11.4 去标识化</h3>
    <p>
      是指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。
    </p>
    <h3>11.5 删除</h3>
    <p>
      在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
    </p>
    <p>
      注：前述名词定义出自《个人信息保护法》。如对本个人信息保护政策其他名词有疑问的，可参考前述法定规定，或者您可以通过本政策列明的方式与我们联系。
    </p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  methods: {
    goBack() {
      this.$emit("go-back");
    },
  },
};
</script>

<style scoped lang='less'>
.privacy-policy {
  position: relative;
  z-index: 111;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  padding: 20px;
  max-width: 800px;
  margin: 100px auto;
}
.top-head {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  z-index: 11;
  padding: 5px;
  border-radius: 20px;

  .logout-button {
    padding: 10px 20px;
    background-color: #dc3545;
    border: none;
    border-radius: 6px;
    color: white;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #c82333;
    }
  }
}
.privacy-policy h1 {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
}

.privacy-policy ol {
  margin: 20px 0;
  padding-left: 20px;
}

.privacy-policy ol li {
  margin-bottom: 10px;
}

.privacy-policy p {
  margin-bottom: 20px;
}
.privacy-policy h2,
.privacy-policy h3 {
  font-weight: bold;
  color: black;
}

.privacy-policy p {
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/info-protect.vue